export const defaultClasses =
  'flex text-icon-reversed items-center bg-button-transparent h-5 w-5 shrink-0 rounded-sm border justify-center ring-offset-white outline-gray-900 border-gray-900 text-gray-0';

export const checkedClasses = 'data-[state=checked]:bg-gray-900 data-[state=checked]:border-gray-900';

export const hoverClasses = 'data-[state=unchecked]:hover:bg-gray-50';

export const indicatorClasses = 'text-gray-0';

export const disabledClasses = 'disabled:border-gray-600 disabled:bg-gray-100 disabled:text-gray-600 disabled:cursor-not-allowed';

export const focusedClasses =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-900 focus-visible:ring-1';

export const wrapperClasses = 'flex items-center align-middle gap-2 w-full';

export const wrapperHadLabelClasses =
  '[&:has(:focus-visible)]:outline outline-offset-2 [&:has(:focus-visible)]:outline-gray-900 [&:has(:focus-visible)]:outline-1';

export const labelClasses = 'body-s items-center flex w-full cursor-pointer leading-normal gap-x-[2px]';

export const labelColorClasses = 'text-gray-900';

export const labelDisabledClasses = 'text-gray-600';
